module.exports = __webpack_public_path__ + "img/big_kegs_open.430a121a.svg";